<template>
  <div>

<!-- <div v-for="img in yapasImages" :key="img.src">
  <img
    :src="img.src"
    style="max-width: 100px;"
    
  >
  <div>{{ img.name }}</div>
</div>  -->

    <div class="filter-row">

      <!-- SOL: FİLTRELER -->
      <div class="filter-left">

        <div class="filter-field filter-small">
          <label class="filter-label">Anagrup</label>
            <select
              v-model="filters.anagrup"
              class="filter-control"
              @change="onAnagrupChange"
            >
              <option value="">Tümü</option>
              <option v-for="v in anagrupOptions" :key="'ana-'+v" :value="v">
                {{ v }}
              </option>
            </select>

        </div>

        <div class="filter-field filter-small">
          <label class="filter-label">Altgrup</label>
            <select
              v-model="filters.altgrup"
              class="filter-control"
              :disabled="!filters.anagrup"
              @change="onAltgrupChange"
              :key="filters.anagrup"  
            >
              <option value="">Tümü</option>
              <option v-for="v in altgrupOptions" :key="'alt-'+v" :value="v">
                {{ v }}
              </option>
            </select>

        </div>

        <div class="filter-field filter-small">
          <label class="filter-label">Marka</label>
          <select v-model="filters.marka" class="filter-control">
            <option value="">Tümü</option>
            <option
              v-for="v in markaOptions"
              :key="'marka-'+v"
              :value="v"
            >
              {{ v || '(Boş)' }}
            </option>
          </select>
        </div>

        <div class="filter-field filter-name">
          <label class="filter-label">İsim</label>
          <input
            v-model="globalKeyword"
            type="text"
            class="filter-control"
            placeholder="İsimde ara..."
          />
        </div>

      </div>

      <!-- SAĞ: LEGEND + TOPLAM -->
      <div class="filter-right">
        <div class="stock-legend" style="margin-top: 25px;">

          <span class="legend-item">
            <span class="legend-dot legend-dot-ok"></span> Stok var
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-critical"></span> Kritik stok
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-onway"></span> Stok yolda
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-none"></span> Stok yok
          </span>
        </div>

        <div class="stock-count">
          Toplam <strong>{{ toplamUrun }}</strong> ürün
        </div>
      </div>

    </div>
 
    <div class="product-grid" v-if="items && items.length">

      <div class="product-card" v-for="(s, idx) in items" :key="s.id + '-' + idx"  style="cursor:pointer">
        <span v-if="s.kampanya" style="position:absolute; background:firebrick; color: white; font-size:13px; padding:3px; border-radius:3px">Kampanya</span>
        <div @click="openBasketPopup(s)">
          <div class="product-img">
          <img :src="s.url && s.url !== '' ? s.url : (s.ambalaj ? '/upload/' + s.ambalaj + '.jpg' : '/img/no-image.png')"
         @error=" $event.target.onerror = null; $event.target.src = '/src/static/resimyok.jpg'; " >
        </div>
          <div class="product-name" :style="isimStyle(s)">{{ s.isim }}</div>
          <div class="product-code">Ürün Kodu: {{s.kod}}</div>
          <div class="product-code" style="color:red" v-if="s.bFiyat>0">Tavsiye Edilen Satış Fiyatı {{$helper.parabirimi(s.bFiyat,hesap.pb)}}</div>
<!--  -->
        </div>


        <div class="product-footer">
          <div class="price-block"> 

            <span class="price-value">{{$helper.parabirimi(($helper.kdvlimi((s.fiyatDetay.iskontolu),hesap.kdvli,s.kdv).kdvli),hesap.pb)}}</span>
            <span class="price-unit">/ {{s.birim}}</span>

            
          </div>


          
          <div class="product-actions" @click="openDetailPopup(s)">
            <button class="icon-btn"><span class="icon-search"></span></button>
          </div>
        </div>
        
      </div>

    </div>
  

    <div v-else class="alert alert-warning">
      Filtreye uygun kayıt bulunamadı.
    </div>

    <div v-if="items.length < filtered.length" class="alert">
      <small>Kayıt Sonu</small>
    </div>
<!-- Sepet Popup -->
<transition name="basket-fade">
  <div
    class="basket-modal-backdrop"
    v-if="basketModalOpen"
    @click.self="closeBasketPopup"
  >
    <div class="basket-modal">

      <!-- Header -->
      <div class="basket-modal-header">
        <div class="basket-modal-title">
          {{ selectedBasketProduct ? selectedBasketProduct.isim : '' }}
        </div>
                <div class="stock-legend">

          <span class="legend-item">
            <span class="legend-dot legend-dot-ok"></span> Stok var
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-critical"></span> Kritik stok
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-onway"></span> Stok yolda
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-none"></span> Stok yok
          </span>
        </div>
        <button class="basket-modal-close" @click="closeBasketPopup">×</button>
      </div>

      <!-- Body / Tablo -->
<div class="basket-modal-body">
  <div class="basket-table-header">
    <div class="basket-col basket-col-img"></div>
    <div class="basket-col basket-col-isim">İsim</div>
    <div class="basket-col basket-col-paket">Paket</div>
    <div class="basket-col">Adet</div>
    <div class="basket-col basket-col-paket">Birim</div>

    <div class="basket-col basket-col-price">Fiyat</div>
    <div class="basket-col basket-col-total">Tutar</div>
  </div>

  <div class="basket-table-row" v-for="row in basketRows" :key="row.id">
    <div class="basket-col basket-col-img">
      <div class="basket-img-box" :class="rowBorderClass(row)">
        <img class="basket-img"  :class="rowBorderClass(row)" :src="row.url && row.url !== '' ? row.url : (row.ambalaj ? '/upload/' + row.ambalaj + '.jpg' : '/img/no-image.png')"
         @error=" $event.target.onerror = null; $event.target.src = '/src/static/resimyok.jpg'; " >   
      </div>
    </div>

    <!-- SAĞ BLOK -->
    <div class="basket-row-main">
      <!-- Üst satır: İsim + Marka -->
      <div class="basket-row-top">
<div class="basket-col basket-col-isim">
  <div class="basket-name-line">
    {{ row.kod }}-{{ row.marka }} {{ $helper.ilkharfBuyuk(row.isim) }}
  </div>

  <input
    class="basket-note-input"
    type="text"
    v-model="row.note"
    maxlength="49"
    placeholder="Not (max 50 karakter)"
  />
</div>

        
        <div class="basket-col basket-col-marka">
          <select v-model="row.unitKey" class="qty-unit-select">
            <option value="birim">{{ row.birim }}</option>
            <option v-if="row.birim2" value="birim2">{{ row.birim2 }}</option>
          </select>
        </div>
       
      </div>


      <div class="basket-row-bottom">
        <!-- MOBİLDE GÖSTERİLECEK BİRİM SELECT (ALT SATIR) -->
        <div class="basket-col basket-col-unit-mobile">
        <select v-model="row.unitKey" class="qty-unit-select">
          <option value="birim">{{ row.birim }}</option>
          <option v-if="row.birim2" value="birim2">{{ row.birim2 }}</option>
        </select>
        </div>

                <div class="basket-col basket-col-qty">


          <button class="qty-btn" @click="decRow(row)">−</button>
          <input
            type="text"
            class="qty-input"
            v-model.number="row.adet"
          >
          <button class="qty-btn" @click="incRow(row)">+</button>
        </div>

        <div class="basket-col basket-col-paket">
          {{ row.paket }}
        </div>

        <div class="basket-col basket-col-price">
          {{$helper.parabirimi(($helper.kdvlimi((row.fiyatDetay.iskontolu),hesap.kdvli,row.kdv).kdvli),hesap.pb)}}
                      <span class="price-value"></span>

          
        </div>

        <div class="basket-col basket-col-total">
          {{$helper.parabirimi(($helper.kdvlimi((row.fiyatDetay.iskontolu),hesap.kdvli,row.kdv).kdvli)*row.adet,hesap.pb)}}
        </div>
      </div>
    </div>
  </div>

</div>


      <!-- Footer -->
      <div class="basket-modal-footer">
        <div class="basket-footer-total">
          {{ $helper.parabirimi(basketTotal,hesap.pb) }} Kdv Dahil
        </div>
        <button class="basket-footer-btn" @click="confirmBasket">
          Sepete Ekle
        </button>
      </div>

    </div>
  </div>
</transition>
<transition name="basket-fade">
  <div class="basket-modal-backdrop" v-if="detailModalOpen" @click.self="closeBasketPopup">
    <div class="basket-modal">

      <!-- Header -->
      <div class="basket-modal-header">
        <div class="basket-modal-title">
          {{ selectedBasketProduct ? selectedBasketProduct.isim : '' }}
        </div>
                <div class="stock-legend">

          <span class="legend-item">
            <span class="legend-dot legend-dot-ok"></span> Stok var
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-critical"></span> Kritik stok
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-onway"></span> Stok yolda
          </span>
          <span class="legend-item">
            <span class="legend-dot legend-dot-none"></span> Stok yok
          </span>
        </div>        
        <button class="basket-modal-close" @click="closeDetailPopup">×</button>
      </div>
<div class="product-tabs">

  <!-- TAB HEADERS -->
  <div class="tabs-header">
    <div
      class="tab-item"
      :class="{ active: activeTab === 'info' }"
      @click="activeTab = 'info'"
    >
      Ürün Bilgisi
    </div>

    <div
      class="tab-item"
      :class="{ active: activeTab === 'options' }"
      @click="activeTab = 'options'"
    >
      Seçenekler
    </div>
      <!-- @click="stokHareket(selectedBasketProduct.kod)" -->

    <div
      class="tab-item"
      :class="{ active: activeTab === 'history' }"
    >
      Hareket
    </div>
  </div>

  <!-- TAB CONTENT -->
  <div class="tabs-body">

    <!-- ÜRÜN BİLGİSİ -->
    <div v-show="activeTab === 'info'" class="tab-panel">
      <div class="product-info-layout">

        <!-- SOL: FOTO -->
        <div class="product-photo" >
            <img :src="selectedBasketProduct.url && selectedBasketProduct.url !== ''  ? selectedBasketProduct.url  : ('/upload/' + selectedBasketProduct.ambalaj + '.jpg')"
            @error=" $event.target.onerror = null; $event.target.src = '/src/static/resimyok.jpg'; " >
        </div>

        <!-- SAĞ: METİN -->
        <div class="product-text">
          <h2 class="product-title">{{ selectedBasketProduct.isim }}</h2>

          <div class="product-row">
            <span>Kod</span>
            <b>{{ selectedBasketProduct.kod }}</b>
          </div>

          <div class="product-row">
            <span>Marka</span>
            <b>{{ selectedBasketProduct.marka }}</b>
          </div>

          <div class="product-row">
            <span>Birim</span>
            <b>{{ selectedBasketProduct.birim }}</b>
            <b v-if="selectedBasketProduct.katsayi2*-1>0" > {{ selectedBasketProduct.birim2 }}  {{ selectedBasketProduct.katsayi2*-1 }} Adet </b>
          </div>
                   
          <div class="product-row">
            <span>Fiyat</span>
            <b>{{$helper.parabirimi(($helper.kdvlimi((selectedBasketProduct.fiyatDetay.iskontolu),hesap.kdvli,selectedBasketProduct.kdv).kdvli),hesap.pb)}} <span style="font-weight:normal; font-size:13px">
              KDV Dahil
            </span></b> 
          </div>

          <div class="product-desc">
            {{ selectedBasketProduct.aciklama || 'Açıklama Bulunamadı' }}
          </div>
        </div>

      </div>
    </div>

    <!-- SEÇENEKLER -->
    <div v-show="activeTab === 'options'" class="tab-panel">
      <!-- BURAYI SEN DOLDURACAKSIN -->
        <div class="basket-table-row" v-for="row in basketRows" :key="row.id" >
          <!-- Görsel -->
          <div class="basket-col basket-col-img">
            <div class="basket-img-box" @click="stokHareket(row.kod)">
              <img class="basket-img"  :class="rowBorderClass(row)"
  :src="row.url && row.url !== ''
    ? row.url
    : (row.ambalaj ? '/upload/' + row.ambalaj + '.jpg' : '/img/no-image.png')"
  @error="
    $event.target.onerror = null;
    $event.target.src = '/src/static/resimyok.jpg';
  "
>
            </div>
          </div>

          <!-- SAĞ BLOK -->
          <div class="basket-row-main">
            <!-- Üst satır: İsim + Marka -->
            <div class="basket-row-top">
              <div class="basket-col basket-col-isim">
                {{ $helper.ilkharfBuyuk(row.isim) }}
              </div>
              <div class="basket-col basket-col-marka">
                {{ row.kod}}
                {{row.marka}}

              </div>
            </div>

            <!-- Alt satır: Adet + Paket + Fiyat + Tutar -->
            <div class="basket-row-bottom">
              <div v-if="hesap.tip==1"  class="basket-col basket-col-paket">
               Miktar {{ row.stok }}
              </div>

              <div class="basket-col basket-col-paket">
                {{ row.paket }}
                <b v-if="row.katsayi2>0" >İçerik :{{ row.katsayi2 }} Adet </b>
              </div>

              <div class="basket-col basket-col-price">
          {{$helper.parabirimi(($helper.kdvlimi((row.fiyatDetay.iskontolu),hesap.kdvli,row.kdv).kdvli),hesap.pb)}}
                
              </div> 
            </div>
          </div>
        </div>

    </div>

    <!-- HAREKET -->
    <div v-show="activeTab === 'history'" class="tab-panel">

      <div v-if="hesap.tip != 1" class="options-placeholder">
       Bu alanı kullanım yetkiniz bulunmamaktadır
      </div>

      <div v-else class="history-table">

        <div class="history-head">
          <div>Tip</div>
          <div>Tarih</div>
          <div>Cari</div>
          <div>Birim</div>
          <div>Miktar</div>
          <div class="right">Fiyat</div>
        </div>

        <div
          class="history-row"
          v-for="(h, i) in hareketler"
          :key="i"
        >
          <div>Alış</div>
          <div>{{ $helper.trtgoster(h.tarih) }}</div>
          <div>{{ h.cari }}</div>
                    <div>{{ $helper.parabirimi(h.birim,hesap.pb) }}</div>

          <div>{{ h.miktar +' '+selectedBasketProduct.birim }}</div>
          <div class="right">{{ $helper.parabirimi(h.fiyat,hesap.pb) }}</div>
        </div>

      </div>
    </div>

  </div>
</div>
      



    </div>
  </div>
</transition>
  </div>
</template>

<script>
import db from '../../db.js';
import searchStore from '../../store/index.js';
import fiyatHelper from '../../services/fiyat/yapas.js'  // yeni dosya

export default {
  data() {
    return {
    activeTab: 'info',

    hareketler: [ ],      
      hesap:this.$request.ayar(),
      allStocks: [],
      filtered: [],
      items: [],
      page: 1,
      limit: 50,
      loading: false,
      debounceTimer: null,
      filters: {
        anagrup: '',
        altgrup: '',
        marka: ''
      },
      basketModalOpen: false,
      detailModalOpen: false,

      selectedBasketProduct: null,
      popupUnitKey: "birim",
      basketRows: [],
      yapasImages:[],
          ambalajCountMap: {},  // <-- EKLE



};
  },

  computed: {
    toplamUrun () {
    return this.filtered.length // veya this.products.length
    },
    // HEADER + SAYFA aynı keyword
    globalKeyword: {
      get() {
        return searchStore.keyword;
      },
      set(val) {
        searchStore.setKeyword(val);
      }
    },

    // 1) İsim filtresi — boşsa tüm ürünler
keywordFiltered() {
  const key = this.normalizeText(this.globalKeyword);
  if (!key) return this.allStocks;

  return this.allStocks.filter(s => {
    const isim = this.normalizeText(s.isim);
    const kod  = this.normalizeText(s.kod);
    return isim.includes(key) || kod.includes(key);
  });
},
    // 2) Anagrup seçenekleri
anagrupOptions() {
  const set = new Set();
  this.keywordFiltered.forEach(s => s.anagrup && set.add(s.anagrup));
  return this.sortTextList(Array.from(set));
},
    // 3) Altgrup seçenekleri (sadece anagrup seçiliyse)
altgrupOptions() {
  if (!this.filters.anagrup) return [];
  const set = new Set();
  this.keywordFiltered
    .filter(s => s.anagrup === this.filters.anagrup)
    .forEach(s => s.altgrup && set.add(s.altgrup));
  return this.sortTextList(Array.from(set));
},
    // 4) Marka seçenekleri (keyword + anagrup + altgrup'a göre)
markaOptions() {
  let src = this.keywordFiltered;

  if (this.filters.anagrup) {
    src = src.filter(s => s.anagrup === this.filters.anagrup);
  }

  if (this.filters.anagrup && this.filters.altgrup) {
    src = src.filter(s => s.altgrup === this.filters.altgrup);
  }

  const set = new Set();
  src.forEach(s => s.marka && set.add(s.marka));
  return this.sortTextList(Array.from(set));
},
    basketTotal() {
        var total = 0;
        for (var i = 0; i < this.basketRows.length; i++) {
          var r = this.basketRows[i];
          var adet = Number(r.adet || 0);
          var fiyat = Number(this.$helper.kdvlimi((r.fiyatDetay.iskontolu),this.hesap.kdvli,r.kdv).kdvli || 0);
          total += adet * fiyat;
        }
        return total;
      }    
  },
//e.kod = e.ambalaj
async created() {
  this.$store.setLoading([false,''])

  //this.yapasResimleriYukle();

const ambData = await db.stocks
    .where('ambalaj')
    .notEqual("")   // boş gelmesin
    .toArray();

  // 2) Ambalaj kodlarını uniq listeye çevir
  const ambCodes = [...new Set(ambData.map(x => x.ambalaj))];

  //this.allStocks = await db.stocks.toArray();
  this.allStocks = await db.stocks .where('kod') .anyOf(ambCodes).toArray();
  const map = {};
for (let i = 0; i < ambData.length; i++) {
  const k = String(ambData[i].ambalaj || '');
  if (!k) continue;
  map[k] = (map[k] || 0) + 1;
}
this.ambalajCountMap = map;
  this.loading = false;  // başlangıç durumu
  this.applyFilters();
},
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  watch: {
    globalKeyword() {
      this.debounceApplyFilters();
    },
    'filters.marka'() {
      this.debounceApplyFilters();
    }
  },

  methods: {
normalizeText(val) {
  return String(val || '')
    .trim()
    .toLocaleLowerCase('tr-TR');
},

sortTextList(list) {
  return [...list].sort((a, b) =>
    String(a || '').localeCompare(String(b || ''), 'tr', {
      sensitivity: 'base',
      numeric: true
    })
  );
},

 sortStockListByName(list) {
   return [...list].sort((a, b) =>
     String((a && a.isim) || '').localeCompare(
       String((b && b.isim) || ''),
       'tr',
       {
         sensitivity: 'base',
         numeric: true
       }
     )
   );
 },

 sortStockListByGroup(list) {
   return [...list].sort((a, b) => {
     const aAna = String((a && a.anagrup) || '');
     const bAna = String((b && b.anagrup) || '');
     const anaCmp = aAna.localeCompare(bAna, 'tr', { sensitivity: 'base', numeric: true });
     if (anaCmp) return anaCmp;

     const aAlt = String((a && a.altgrup) || '');
     const bAlt = String((b && b.altgrup) || '');
     const altCmp = aAlt.localeCompare(bAlt, 'tr', { sensitivity: 'base', numeric: true });
     if (altCmp) return altCmp;

     const aIsim = String((a && a.isim) || '');
     const bIsim = String((b && b.isim) || '');
     const isimCmp = aIsim.localeCompare(bIsim, 'tr', { sensitivity: 'base', numeric: true });
     if (isimCmp) return isimCmp;

     const aKod = String((a && a.kod) || '');
     const bKod = String((b && b.kod) || '');
     return aKod.localeCompare(bKod, 'tr', { sensitivity: 'base', numeric: true });
   });
 },

    debounceApplyFilters() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.applyFilters();
      }, 200);
    },

applyFilters() {

  const key = this.normalizeText(this.globalKeyword);
  let { anagrup, altgrup, marka } = this.filters;

  let base = this.allStocks;

if (key) {
  base = base.filter(s => {
    const isim = this.normalizeText(s.isim);
    const kod  = this.normalizeText(s.kod);
    return isim.includes(key) || kod.includes(key);
  });
}

  if (anagrup) {
    base = base.filter(s => s.anagrup === anagrup);
  }

  // altgrup, mevcut anagrup için hala geçerli mi?
  if (anagrup && altgrup && !this.altgrupOptions.includes(altgrup)) {
    altgrup = '';
    this.filters.altgrup = '';
  }

  if (anagrup && altgrup) {
    base = base.filter(s => s.altgrup === altgrup);
  }

  // aynı mantığı marka için de istersen markaOptions ile yapabilirsin

  if (marka && !this.markaOptions.includes(marka)) {
    marka = '';
    this.filters.marka = '';
  }

  if (marka) {
    base = base.filter(s => (s.marka || '') === marka);
  }

 this.filtered = this.sortStockListByGroup(base);  this.page = 1;
  this.items = [];
  this.loadMore();
},

async loadMore() {
  if (this.loading) {
    return;
  }

  this.loading = true;
  this.$store.setLoading([true, 'Ürünler yükleniyor...']);

  try {
    var start = (this.page - 1) * this.limit;
    var end   = this.page * this.limit;

    var chunk = this.filtered.slice(start, end);

    if (!chunk.length) {
      return;
    }
    

    var enhancedChunk = [];
    var i;

    for (i = 0; i < chunk.length; i++) {
      var s = chunk[i];

      var extra = {
        fiyat: s.fiyat || 0,
        kdv:   s.kdv   || 0
      };

      // fiyat hesapla (iskonto + kdv hariç)
      var fiyat = await fiyatHelper.getFiyat(
        extra,
        this.$helper,
        this.hesap.kdvli,
        this.$store.aktifCari.iskontokod,
        0, // kampanya
        s.doviz || 0
      );
      var net;

      if (typeof fiyat.iskontolu === 'number' && !isNaN(fiyat.iskontolu)) {
        net = fiyat.iskontolu;
      } else {
        net = fiyat.liste;
      }

      enhancedChunk.push(Object.assign({}, s, {
        // ekranda göstereceğin fiyat
        gosterimFiyati:net,
        // istersen açılır detay vs. için tüm fiyat objesi
        fiyatDetay: fiyat
      }));
    }

    this.items = this.items.concat(enhancedChunk);
    this.page++;
  } catch (e) {
    console.error('loadMore error:', e);
  } finally {
    this.loading = false;
    this.$store.setLoading([false, '']);
  }
},

onAnagrupChange() {
    this.$store.setLoading([true,'']);
    // anagrup değişiyorsa altgrup ve marka mantıksızlaşır → temizle
    this.filters.altgrup = '';
    this.filters.marka = '';
    setTimeout(() => { this.applyFilters();  }, 100)
},
onAltgrupChange() {
    this.$store.setLoading([true,'']);
    
    this.filters.marka = '';
    setTimeout(() => { this.applyFilters();  }, 100)
},
onScroll() {

      const scrollPos = window.innerHeight + window.pageYOffset;
      const bottom = document.body.scrollHeight - 150;

      if ( scrollPos >= bottom && !this.loading && this.items.length < this.filtered.length  ) {
          this.loadMore();
      }


},
async openBasketPopup(stock) {

  this.selectedBasketProduct = stock;
  //this.popupUnitKey = (stock && stock.birim2) ? 'birim2' : 'birim';

  // 1️⃣ Ambalaj kodunu al
  const ambKod = stock.ambalaj;

  // güvenlik
  if (!ambKod) {
    console.warn("Bu ürünün ambalaj kodu yok!");
    this.basketModalOpen = true;
    this.basketRows = [];
    return;
  }

  // 2️⃣ Aynı ambalaja bağlı tüm ürünleri çek
  // index var ise ultra hızlı
  const ambalajliUrunler = await db.stocks
    .where("ambalaj")
    .equals(ambKod)
    .toArray();
const aktifCari = this.$store.aktifCari;

const rows = await Promise.all(
  ambalajliUrunler.map(async u => {
    const fiyatObj = await fiyatHelper.getFiyat( { fiyat: u.fiyat, kdv:u.kdv }, this.$helper,this.hesap.kdvli , aktifCari.iskontokod ,0,u.doviz || 0);
    const netFiyat = typeof fiyatObj.iskontolu === 'number' ? fiyatObj.iskontolu : fiyatObj.liste;
    const basketRow = aktifCari.basket.find(b => b.guid === u.id);

    return {
      id: u.id,
      isim: u.isim,
      foto: u.ambalaj || null, // gerek yok
      stok: u.miktar || 0,
      adet: basketRow ? basketRow.adet : 0,
      note:basketRow ? basketRow.note : '',
      fiyatDetay: fiyatObj,
      ambalaj: u.ambalaj,
      paket: u.birim,
      kod: u.kod,
      kdv:u.kdv,
      url : u.url  || '',
      birim: u.birim || '',
      birim2: u.birim2 || '',
      katsayi1: Number(u.katsayi1 || 1),
      katsayi2: Number(u.katsayi2 || 0),

  // YENİ: satır bazlı seçili birim
  unitKey: (u.birim2 && Number(u.katsayi2 || 0) > 0) ? 'birim2' : 'birim'
    };
  })
);

this.basketRows = rows;


  // 4️⃣ Popup'ı aç
  this.basketModalOpen = true;
},
async openDetailPopup(stock) {
  this.selectedBasketProduct = stock;
this.hareketler = [];
this.activeTab = 'info'
  // 1️⃣ Ambalaj kodunu al
  const ambKod = stock.ambalaj;

  // güvenlik
  if (!ambKod) {
    console.warn("Bu ürünün ambalaj kodu yok!");
    this.basketModalOpen = true;
    this.basketRows = [];
    return;
  }

  const ambalajliUrunler = await db.stocks
    .where("ambalaj")
    .equals(ambKod)
    .toArray(); 
const aktifCari = this.$store.aktifCari;

const rows = await Promise.all(
  ambalajliUrunler.map(async u => {
    const fiyatObj = await fiyatHelper.getFiyat( { fiyat: u.fiyat, kdv:u.kdv }, this.$helper,this.hesap.kdvli , aktifCari.iskontokod ,0,u.doviz || 0);
    const netFiyat = typeof fiyatObj.iskontolu === 'number' ? fiyatObj.iskontolu : fiyatObj.liste;
    const basketRow = aktifCari.basket.find(b => b.guid === u.id);

    return {
      id: u.id,
      isim: u.isim,
      foto: u.ambalaj || null,
      stok: u.miktar || 0,
      adet: basketRow ? basketRow.adet : 0,
      fiyatDetay: fiyatObj,
      ambalaj: u.ambalaj,
      paket: u.birim,
      kod: u.kod,
      kdv:u.kdv,
      birim: u.birim || '',
      birim2: u.birim2 || '',
      url : u.url  || '',
      //bfiyat : u.bfiyat,
      katsayi1: Number(u.katsayi1 || 1),
      katsayi2: Number(u.katsayi2 || 0),
      unitKey: (u.birim2 && Number(u.katsayi2 || 0) > 0) ? 'birim2' : 'birim'      
    };
  })
);

this.basketRows = rows;


  // 4️⃣ Popup'ı aç
  this.detailModalOpen = true;
},
  closeBasketPopup() {
    this.basketModalOpen = false;
  },
  closeDetailPopup() {
    this.detailModalOpen = false;
  },
incRow(row) {
  var stok = Number(row.stok || 0);
  var adet = Number(row.adet || 0);

  var step = 1;
  if (row.unitKey === 'birim2') {
    step = Math.abs(Number(row.katsayi2 || 1)) || 1;
  } else {
    step = Math.abs(Number(row.katsayi1 || 1)) || 1;
  }

  if (adet + step <= stok) {
    row.adet = adet + step;
  } else if (adet < stok) {
    row.adet = stok;
  }
},

decRow(row) {
  var adet = Number(row.adet || 0);

  var step = 1;
  if (row.unitKey === 'birim2') {
    step = Math.abs(Number(row.katsayi2 || 1)) || 1;
  } else {
    step = Math.abs(Number(row.katsayi1 || 1)) || 1;
  }

  var yeni = adet - step;
  row.adet = (yeni > 0) ? yeni : 0;
},
rowDurum(row) {
  const miktar = Number(row.stok || 0);
  const min = Number(row.min || 0); // stok kartında minimum alanın neyse

  if (miktar > min) return 1;                 // yeterli
  if (miktar > 0 && miktar < min) return 2;   // kritik
  if (miktar === 0) return 4;                 // yok
  return 0;
}, 
rowBorderClass(row) {
  const d = this.rowDurum(row);
  switch (d) {
    case 1: return 'img-border-ok';
    case 2: return 'img-border-warning';
    case 4: return 'img-border-danger';
    default: return '';
  }
} ,

  formatPrice(val) {
    var n = Number(val || 0);
    // istersen direkt this.$helper.parabirimi kullan:
    // return this.$helper.parabirimi(n, this.hesap.pb);
    return n.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  },

async confirmBasket() {
    this.$store.setLoading([true,'Bekleyiniz'])

  // 1) Aktif cariyi IndexedDB'den çek
  var aktifCari = this.$store.aktifCari

  if (!aktifCari) {
    console.warn('Aktif cari bulunamadı');
    return;
  } 
  // 2) Popup içindeki satırlardan, gönderilecekleri sıraya göre hazırla
  var rowsToSend = this.basketRows
    .map(function (r, index) {
      return {
        sira: index + 1,            // UI'daki görüntü sırası
        guid: r.id,
        adet: Number(r.adet || 0),
        kod: r.kod,
        ambalaj: r.ambalaj,
        note:r.note
      };
    })
    .filter(function (r) {
      return r.adet > 0;            // adet 0 olanları göndermiyoruz
    });

  if (!rowsToSend.length) {
    // seçili/pozitif adet yoksa popup'ı kapat yeter
    this.basketModalOpen = false;
    return;
  }

  // 3) Mevcut basket'in kopyası (diğer ürünler korunacak)
  var newBasket = Array.isArray(aktifCari.basket)
    ? aktifCari.basket.slice()
    : [];

  // 4) Her satırı endpoint'e TEK TEK sırayla gönder
  for (var i = 0; i < rowsToSend.length; i++) {
    var row = rowsToSend[i];
    try {
      let obje = { giden: this.$helper.point(aktifCari.kod, [], [], [],row.guid, '', 1, 0, 0, 0, 'isim', 'asc', 1),adet: row.adet, durum: 1,note:row.note }
      var res = await this.$request.post('basket/add', obje);

      if (res.status == 302) {
        res = await this.$request.post('basket/update', obje);
      }

      // API cevabını kendi yapına göre uyarlayacaksın
      // Örnek varsayım:
      // res.data = { success: true, item: { guid, adet, sira } }
      //var data = res && res.data ? res.data : null;

      if (res.status !=200 && res.status != 302 ) {
        // backend "başarısız" dediyse local basket'i değiştirme
        continue; //döngünün geri kalan satırlarını çalıştırmaz
      }


      var updatedGuid = row.guid;
      var updatedAdet = row.adet;
      var updatedNote = row.note;
      var updatedDate = new Date().toISOString();

      // 5) newBasket içinde bu guid var mı?
      var idx = -1;
      for (var j = 0; j < newBasket.length; j++) {
        if (newBasket[j].guid === updatedGuid) {
          idx = j;
          break;
        }
      }

      if (idx === -1) {
        // Sepette yoksa yeni ürün olarak ekle
        newBasket.push({
          guid: updatedGuid,
          adet: updatedAdet,
          note:updatedNote,
          updateAt: updatedDate
        });
      } else {
        // Varsa adet ve sırayı güncelle (diğer alanlara dokunma)
        var mevcut = newBasket[idx];
          newBasket[idx] = Object.assign({}, mevcut, {
          adet: updatedAdet,
          note:updatedNote,
          updateAt: updatedDate

        });
      }

    } catch (e) {
      this.$store.setLoading([false,''])
      console.error('basketUpdate hata:', e);
      this.$store.showNotify({
        type: 'danger',
        text: `Sepet Hatası`,
        timeout: 3000
      });
      // İstersen burada kullanıcıya uyarı gösterebilirsin
      // this.$helper.toast('Sepete eklenirken hata oluştu');
    }
  }

  // 6) Endpoint'ten başarılı geçen satırlara göre DB'de cari basket'i güncelle
  await db.caris
    .where('guid')
    .equals(aktifCari.guid)
    .modify({ basket: newBasket }); 
          this.$store.setLoading([false,''])
          this.$store.showNotify({
            type: 'success',
            text: `Sepet Güncellendi`,
            timeout: 3000
          });
},

async yapasResimleriYukle() {
    var folderPublicKey = 'https://disk.yandex.com/d/5otZx-mlC-YFyg';

    // 1) Klasör içeriğini listele
    var listUrl = 'https://cloud-api.yandex.net/v1/disk/public/resources'
      + '?public_key=' + encodeURIComponent(folderPublicKey)
      + '&limit=1000';

    try {
      var res = await fetch(listUrl);
      var data = await res.json();

      if (!res.ok) {
        console.error('Yandex LIST hata:', res.status, data);
        this.yapasImages = [];
        return;
      }

      var items = (data._embedded && data._embedded.items) ? data._embedded.items : [];

      // 2) Sadece image dosyaları
      var imageItems = items.filter(function (i) {
        return (
          i.type === 'file' &&
          i.mime_type &&
          i.mime_type.indexOf('image/') === 0
        );
      });

      // 3) Her image için GERÇEK download href al
      var promises = imageItems.map(function (item) {
        // klasörün kökünde: path = "/" + dosyaAdı
        var path = '/' + item.name;  // Örn: "/-AK 734+.jpg"

        var dlUrl = 'https://cloud-api.yandex.net/v1/disk/public/resources/download'
          + '?public_key=' + encodeURIComponent(folderPublicKey)
          + '&path=' + encodeURIComponent(path);

        return fetch(dlUrl)
          .then(function (r) {
            return r.json().then(function (d) {
              return { ok: r.ok, status: r.status, data: d, item: item };
            });
          });
      });

      var results = await Promise.all(promises);

      this.yapasImages = results
        .filter(function (r) {
          var ok = r.ok && r.data && r.data.href && r.data.href.length > 0;
          if (!ok) {
            console.error('Yandex DOWNLOAD hata:', r.status, r.data);
          }
          return ok;
        })
        .map(function (r) {
          return {
            src: r.data.href,    // <img src> burası
            name: r.item.name    // istersen yazı için
          };
        });

      console.log('YAPAS DOWNLOAD URL LISTESI:', this.yapasImages);
    } catch (e) {
      console.error('GENEL HATA:', e);
      this.yapasImages = [];
    }
  },
//mnvbmnvbmn
stokHareket(skod) {
  this.activeTab = 'history'
  this.$store.setLoading([true,'Bekleyiniz'])

        this.$request.post(this.hesap.program + "/stok/hareket/alis", {skod:skod}).then(res => {
            if (res.status != 300) {
            this.hareketler = res.data
            this.$store.setLoading([false,'Bekleyiniz'])
            }
            else {
            this.$store.setLoading([false,'Bekleyiniz'])
            this.$router.push("/oturum")
            }


          })
          .catch((err) => {
            //this.$swal("Birşeyler ters gitti tekrar dene" + err);
          });
},

isimStyle(s) {
  const amb = String((s && s.ambalaj) ? s.ambalaj : '');
  if (!amb) return {};

  const count = Number(this.ambalajCountMap[amb] || 0);
  if (count > 1) {
    return { color: '#dc2626', fontWeight: '600' };
  }
  return {};
},

  }

};
</script>
<style scoped>

.product-tabs{
  background:#fff;
  border-radius:14px;
  overflow:hidden;
}

/* Tabs */
.tabs-header{
  display:flex;
  border-bottom:1px solid #e5e7eb;
  background:#f9fafb;
}

.tab-item{
  padding:12px 18px;
  cursor:pointer;
  font-size:14px;
  font-weight:700;
  color:#6b7280;
  border-bottom:3px solid transparent;
}

.tab-item.active{
  color:#111827;
  border-bottom-color:#2563eb;
  background:#fff;
}

/* Body */
.tabs-body{
  padding:16px;
}

.tab-panel{
  animation: fade .15s ease;
}

@keyframes fade{
  from{ opacity:0 }
  to{ opacity:1 }
}

/* Ürün Bilgisi */
.product-info-layout{
  display:grid;
  grid-template-columns: 260px 1fr;
  gap:16px;
}

.product-photo{
  border:1px solid #e5e7eb;
  border-radius:12px;
  overflow:hidden;
  background:#f9fafb;
}

.product-photo img{
  width:100%;
  height:100%;
  object-fit:contain;
}

.product-text{
  display:flex;
  flex-direction:column;
}

.product-title{
  font-size:18px;
  font-weight:800;
  margin-bottom:12px;
}

.product-row{
  display:flex;
  justify-content:space-between;
  padding:6px 0;
  font-size:14px;
  border-bottom:1px dashed #e5e7eb;
}

.product-desc{
  margin-top:12px;
  font-size:14px;
  color:#374151;
}

/* Seçenekler */
.options-placeholder{
  padding:30px;
  border:2px dashed #e5e7eb;
  border-radius:12px;
  text-align:center;
  color:#6b7280;
}

/* Hareket Tablosu */
.history-table{
  border:1px solid #e5e7eb;
  border-radius:12px;
  overflow:hidden;
}

.history-head,
.history-row{
  display:grid;
  grid-template-columns: 80px 100px 1fr 80px 50px 120px;
  padding:10px 12px;
  font-size:13px;
}

.history-head{
  background:#f9fafb;
  font-weight:800;
  color:#6b7280;
}

.history-row{
  border-top:1px solid #f1f5f9;
}

.history-row:hover{
  background:#f9fafb;
}

.right{
  text-align:right;
}

/* Responsive */
@media(max-width:768px){
  .product-info-layout{
    grid-template-columns: 1fr;
  }
}



/* FİLTRE SATIRI ------------------------------------------------ */

.filter-row {
  padding: 0.32rem 0.48rem;
  background: #f7f7f7;
  border-top: 0.026667rem solid #e5e7eb;
  border-bottom: 0.026667rem solid #e5e7eb;
  display: flex;
  align-items: center;          /* Sağ taraf sol ile dikey ortalı */
  justify-content: space-between;
  gap: 0.48rem;
}

/* SOL: FİLTRELER */
.filter-left {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 0.32rem;
  min-width: 0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.106667rem;
  min-width: 0;
}

/* 3 küçük select */
.filter-small {
  flex: 0 0 6.4rem;     /* yaklaşık 120–130px gibi */
}

/* İsim inputu genişlesin */
.filter-name {
  flex: 1 1 auto;
}

/* Label + input stilleri (senin öncekilerle aynı mantık) */
.filter-label {
  font-size: 0.373333rem;
  font-weight: 500;
  color: #4b5563;
}

.filter-control {
  width: 100%;
  height: 1.333333rem;
  border: 0.026667rem solid #d1d5db;
  border-radius: 0.16rem;
  padding: 0 0.32rem;
  font-size: 0.4rem;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.filter-control:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 0.026667rem rgba(99, 102, 241, 0.3);
}

.filter-control:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

/* SAĞ: LEGEND + TOPLAM (PC) */
.filter-right {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.16rem;
  font-size: 0.4rem;
  white-space: nowrap;
}

.stock-legend {
  display: flex;
  align-items: center;
  gap: 0.426667rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.133333rem;
}

.legend-dot {
  width: 0.32rem;
  height: 0.32rem;
  border-radius: 999px;
  display: inline-block;
}

/* Renkler */
.legend-dot-dark      { background: #484848; }

.legend-dot-ok       { background: #22c55e; }
.legend-dot-critical { background: #facc15; }
.legend-dot-onway    { background: #0ea5e9; }
.legend-dot-none     { background: #ef4444; }

.stock-count {
  font-size: 0.4rem;
}

.stock-count strong {
  font-weight: 600;
}

/* 📱 MOBİL + TABLET (≤ 1024px) ---------------------------- */

@media (max-width: 1024px) {
  .filter-row {
    flex-direction: column;
    align-items: stretch;
    padding: 0.32rem 0.32rem;
    gap: 0.32rem;
  }

  .filter-left {
    width: 100%;
    flex-wrap: wrap;
    gap: 0.213333rem;
  }

  /* 3 filtre yan yana eşit */
  .filter-small {
    flex: 1 1 33.333%;
  }

  /* İsim filtresi gizli */
  .filter-name {
    display: none;
  }

  /* Sağ taraf %100 genişlikte, legend solda, toplam sağda */
  .filter-right {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    white-space: normal;
  }

  .stock-legend {
    justify-content: flex-start;
  }

  .stock-count {
    margin-left: auto;
  }
}
/*basket*/
/* Arka plan */
.basket-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Ana kart */
.basket-modal {
  background: #fff;
  border-radius: 8px;
  width: 920px;
  max-width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 13px;
}

/* Header */
.basket-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
}

.basket-modal-title {
  font-size: 14px;
}

.basket-modal-close {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
}

/* Body */
.basket-modal-body {
  padding: 10px 20px 0;
  overflow-y: auto;
}

/* Tablo başlık satırı */
/* MASAÜSTÜ / GENEL DÜZEN */
/* Masaüstü grid düzeni */
.basket-table-header,
.basket-table-row {
  display: grid;
  grid-template-columns:
    70px   /* img */
    4fr    /* isim */
    1fr  /* marka */
    1fr  /* adet */
    0.1fr  /* paket */
    1.1fr  /* fiyat */
    1.1fr; /* tutar */
  column-gap: 10px;
  align-items: center;
}

.basket-table-header {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  color: #777;
}

.basket-table-row {
  padding: 10px 0;
  border-bottom: 1px solid #f1f1f1;
}

/* wrapper'lar desktop'ta görünmez gibi davransın */
.basket-row-main,
.basket-row-top,
.basket-row-bottom {
  display: contents;
}

.basket-col {
  display: flex;
  align-items: center !important;
}

.basket-col-isim {
  font-size: 13px;
  font-weight: 600;
  color: #222;
}

.basket-col-marka {
  font-size: 12px;
  color: #666;
}

/* adet–paket–fiyat–tutar sağ tarafa yaklaşsın */
.basket-col-qty,
.basket-col-paket,
.basket-col-price,
.basket-col-total {
  justify-content: flex-center !important;
}


/* resim */
.basket-img-box {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background: #f5f5f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px !important;
  border: 2px solid transparent !important;
}



.basket-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Adet stepper */
.basket-col-qty {
  justify-content: flex-end;
}
.basket-img {
  border-radius: 6px !important;
  border: 3px solid transparent !important;
}

.img-border-ok {
  border-color: #16a34a !important; /* yeşil */
}

.img-border-warning {
  border-color: #f59e0b; /* turuncu */
}

.img-border-danger {
  border-color: #dc2626 !important; /* kırmızı */
}


.qty-unit-select{
  width: 55px;
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  margin-right: 8px;
  padding: 0 6px;
  font-size: 12px;
}
.qty-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: #f7f7f7;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}

.qty-input {
  width: 40px;
  height: 26px;
  margin: 0 6px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Sağ fiyat kolonları */
.basket-col-price,
.basket-col-total {
  justify-content: flex-end;
}

/* Footer */
.basket-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.basket-footer-total {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.basket-footer-btn {
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  background: #007bff;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

/* Fade animasyonu */
.basket-fade-enter-active,
.basket-fade-leave-active {
  transition: opacity .2s;
}
.basket-fade-enter,
.basket-fade-leave-to {
  opacity: 0;
}

/* Küçük ekranlar: telefon + dikey tablet */
@media (max-width: 768px) {
  .basket-table-header {
    display: none;
  }

  .basket-table-row {
    display: flex;
    align-items: flex-start;
    padding: 10px 0;
  }

  .basket-col-img {
    flex: 0 0 60px;
    max-width: 60px;
    margin-right: 10px;
  }

  .basket-row-main {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  /* Üst satır: isim + marka yan yana */
  .basket-row-top {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .basket-col-isim {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .basket-col-marka {
    font-size: 12px;
    color: #666;
  }

  /* Alt satır: adet + paket + fiyat + tutar */
  .basket-row-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    flex-wrap: wrap;
  }

  .basket-col-qty {
    display: flex;
    align-items: center;
  }

  .basket-col-paket {
    font-size: 12px;
    min-width: 40px;
  }

  .basket-col-price,
  .basket-col-total {
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
    min-width: 60px;
  }

  .basket-col-total {
    font-weight: 600;
  }
}
/* Varsayılan: alt satırdaki mobil birim select gizli */
.basket-col-unit-mobile{
  display: none;
}

@media (max-width: 768px) {

  /* Üst satırdaki birim select mobilde görünmesin */
  .basket-row-top .basket-col-marka{
    display: none;
  }

  /* Alt satırdaki birim select mobilde görünsün ve qty'nin soluna gelsin */
  .basket-col-unit-mobile{
    display: flex;
    align-items: center;
    order: -1;              /* qty'den önce */
  }

  .basket-col-unit-mobile .qty-unit-select{
    width: 52px;
    height: 26px;
    font-size: 12px;
    margin-right: 6px;
  }

  .basket-col-qty{
    order: 0;
  }
}


.basket-col-isim{
  display:flex;
  flex-direction:column;
  align-items:flex-start !important;
  gap:4px;
}

.basket-name-line{
  line-height:1.15;
}

.basket-note-input{
  width: 100%;
  max-width: 95%; /* istersen kaldır, tamamen genişlesin */
  height: 26px;
  font-size: 12px;
  padding: 3px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}




</style>



// WEBPACK FOOTER //
// src/views/stok/arama.vue